import React, { Component } from "react"
import { NamespacesConsumer as I18n } from "react-i18next"
import { connect } from "react-redux"
import { compose } from "redux"
import "../css/NavBarDesktop.css"
import "react-notifications/lib/notifications.css"
import LoadingBar from "react-redux-loading-bar"
import { NotificationContainer } from "react-notifications"
import { API, graphqlOperation } from "aws-amplify"

//component
import MenuNavBarDesktop from "../components/MenuNavBarDesktop"
import * as user_actions from "../actions/action_user"
import * as project_actions from "../actions/action_project"
import Register from "../containers/Registration/Register"
import Login from "../containers/Registration/Login"
import ForgotPassword from "../containers/Registration/ForgotPassword"
import Repassword from "../containers/Registration/Repassword"
import ConfirmRegistration from "../containers/Registration/ConfirmRegistration"
import ContactUs from "./ContactUs"
import Restorename from "../containers/Registration/Restorename"
import * as notification_actions from "../actions/action_notification"
import { subscription } from "../graphql/subscription"

//material ui
import { withStyles } from "@material-ui/core/styles"
import { NavBarDesktopStyle } from "../containers/Style/NavBarDesktopStyle"
class NavBarDesktop extends Component {
	constructor(props) {
		super(props)
		this.state = {
			activeItem: "Home",
			backgroundmenu: false,
			OpenDialogSignup: false,
			OpenDialogSignin: false,
			OpenDialogForgotPassword: false,
			OpenDialogConfirmRegistration: false,
			OpenDialogRepassword: false,
			OpenDialogContactUs: false,
			OpenDialogRestorename: false,
			open: false,
			status: true,
			notificationstate: []
		}
	}

	componentDidMount() {
		document.addEventListener("scroll", this.trackScrolling)
	}
	async UNSAFE_componentWillReceiveProps(nextPorps) {
		if (Object.keys(nextPorps.userInfo).length > 0) {
			if (
				Object.keys(nextPorps.user).length !== 0 &&
				!!!nextPorps.userInfo.given_name &&
				!!!nextPorps.userInfo.family_name
			) {
				this.handleClickOpenRestorename()
			} else {
				this.handleClickCloseRestorename()
			}
		}
		if (Object.keys(this.props.user).length !== 0 && this.state.status) {
			API.graphql(
				graphqlOperation(subscription(this.props.userInfo.user_id))
			).subscribe({
				next: (todoData) =>
					this.props.subscription_notification(
						todoData.value.data.notificationUser
					)
			})
			this.setState({ status: false })
			nextPorps.notification.map(async (item) => {
				let notification_body = JSON.parse(item.notification_body)
				this.props.getprojectnoti(notification_body.project_id).then((res) => {
					if (
						res.value.data.getProject.data.length !== 0 &&
						item.seen === false
					) {
						let notificationstate = [...this.state.notificationstate]
						notificationstate.push(item)
						this.setState({ notificationstate })
						this.props.get_check_noti(notificationstate.length)
					}
				})
			})
			if (this.state.notificationstate.length === 0) {
				this.props.get_check_noti(0)
			}
		} else if (Object.keys(this.props.user).length === 0) {
			API.graphql(graphqlOperation(subscription(nextPorps.userInfo.user_id)))
				.subscribe({
					next: (todoData) =>
						this.props.subscription_notification(
							todoData.value.data.notificationUser
						)
				})
				.unsubscribe()
		}
	}
	componentWillUnmount() {
		document.removeEventListener("scroll", this.trackScrolling)
	}
	handleopen = (name) => {
		if (name === undefined) {
			this.setState({ open: !this.state.open })
		} else if (name === null) {
			this.setState({ open: false })
		} else {
			this.setState({ open: true })
		}
	}
	trackScrolling = () => {
		var offset = document.body.scrollTop || document.documentElement.scrollTop

		if (offset > 50) {
			this.setState({ backgroundmenu: true })
		} else {
			this.setState({ backgroundmenu: false })
		}
	}

	handleItemClick = (e, { name }) => {
		this.setState({ activeItem: name })
		if (name === "Blogs" && localStorage.getItem("LinkedIn") === "true") {
			localStorage.clear()
			localStorage.setItem("UsedCookie", "true")
			localStorage.setItem("Language", "en")
		}
		this.handleopen(null)
	}
	handleClickOpen = (e, name) => {
		e.preventDefault()
		if (name === "Sign in") {
			this.setState({ OpenDialogSignin: true })
		} else if (name === "Sign up") {
			this.setState({ OpenDialogSignup: true })
		} else if (name === "ForgotPassword") {
			this.setState({ OpenDialogForgotPassword: true })
		} else if (name === "ConfirmRegistration") {
			this.setState({ OpenDialogConfirmRegistration: true })
		} else if (name === "Repassword") {
			this.setState({ OpenDialogRepassword: true })
		} else if (name === "Contact us") {
			this.setState({ OpenDialogContactUs: true })
		}
		this.handleopen(null)
	}

	handleClickCloseSignin = () => {
		this.setState({ OpenDialogSignin: false })
	}

	handleClickCloseSignup = () => {
		this.setState({ OpenDialogSignup: false })
	}

	handleClickCloseForgotPassword = () => {
		this.setState({ OpenDialogForgotPassword: false })
	}

	handleClickCloseConfirmRegistration = () => {
		this.setState({ OpenDialogConfirmRegistration: false })
	}

	handleClickCloseRepassword = () => {
		this.setState({ OpenDialogRepassword: false })
	}
	handleClickCloseContactUs = () => {
		this.setState({ OpenDialogContactUs: false })
	}

	handleClickOpenRestorename = () => {
		this.setState({ OpenDialogRestorename: true })
	}
	handleClickCloseRestorename = () => {
		this.setState({ OpenDialogRestorename: false })
	}
	handlegetnotification = async () => {
		const { userInfo, LastEvaluatedKey } = this.props
		await this.props.get_notification(userInfo.user_id, LastEvaluatedKey)
	}
	render() {
		const {
			activeItem,
			backgroundmenu,
			OpenDialogSignup,
			OpenDialogSignin,
			OpenDialogForgotPassword,
			OpenDialogRepassword,
			OpenDialogConfirmRegistration,
			OpenDialogContactUs,
			OpenDialogRestorename,
			open
		} = this.state
		const {
			classes,
			user,
			userInfo,
			notification,
			loading,
			LastEvaluatedKey,
			notseen
		} = this.props

		return (
			<I18n>
				{(t) => {
					return (
						<div>
							<header
								className={backgroundmenu ? "header_area_tran" : "header_area"}
							>
								<LoadingBar
									style={{ backgroundColor: "white", height: "5px", top: 0 }}
								/>
								<div className="main_menu">
									<nav
										className={
											Object.keys(user).length !== 0
												? "navbar navbar-expand-lg navbar-light"
												: backgroundmenu
												? "navbar1 navbar-expand-lg navbar-light"
												: "navbar navbar-expand-lg navbar-light"
										}
									>
										<div className="container">
											<MenuNavBarDesktop
												{...this.props}
												classes={classes}
												user={user}
												userInfo={userInfo}
												activeItem={activeItem}
												handleItemClick={this.handleItemClick}
												handleClickOpen={this.handleClickOpen}
												logout_local={this.props.logout_local}
												notification={notification}
												loading={loading}
												notseen={notseen}
												open={open}
												handleopen={this.handleopen}
												LastEvaluatedKey={LastEvaluatedKey}
												handlegetnotification={this.handlegetnotification}
											/>
										</div>
									</nav>
								</div>
								<Login
									user={user}
									userInfo={userInfo}
									Open={OpenDialogSignin}
									handleClickOpen={this.handleClickOpen}
									handleClickClose={this.handleClickCloseSignin}
									history={this.props.history}
								/>
								<Register
									Open={OpenDialogSignup}
									handleClickClose={this.handleClickCloseSignup}
									history={this.props.history}
								/>
								<ForgotPassword
									handleClickClose={this.handleClickCloseForgotPassword}
									Open={OpenDialogForgotPassword}
									handleClickOpen={this.handleClickOpen}
								/>
								<Repassword
									handleClickClose={this.handleClickCloseRepassword}
									Open={OpenDialogRepassword}
								/>
								<ConfirmRegistration
									handleClickClose={this.handleClickCloseConfirmRegistration}
									Open={OpenDialogConfirmRegistration}
								/>
								<ContactUs
									Open={OpenDialogContactUs}
									handleDialogClose={this.handleClickCloseContactUs}
								/>
								<Restorename
									Open={OpenDialogRestorename}
									handleClickClose={this.handleClickCloseRestorename}
								/>
								<NotificationContainer />
							</header>
						</div>
					)
				}}
			</I18n>
		)
	}
}
function mapStateToProps(reduxState) {
	return {
		user: reduxState.UserReducer.user,
		userInfo: reduxState.UserReducer.userInfo,
		notification: reduxState.NotificationReducer.notification,
		loading: reduxState.NotificationReducer.loading,
		LastEvaluatedKey: reduxState.NotificationReducer.LastEvaluatedKey,
		notseen: reduxState.NotificationReducer.notseen
	}
}
const mapDispatchToProps = function (dispatch) {
	return {
		get_check_noti: (data) =>
			dispatch(notification_actions.get_check_noti(data)),
		getprojectnoti: (projectId) =>
			dispatch(project_actions.getprojectnoti(projectId)),
		logout_local: () => dispatch(user_actions.logout_local()),
		get_notification: (user_id, next_token) =>
			dispatch(notification_actions.get_notification(user_id, next_token)),
		subscription_notification: (data) =>
			dispatch(notification_actions.subscription_notification(data))
	}
}
export default compose(
	withStyles(NavBarDesktopStyle),
	connect(mapStateToProps, mapDispatchToProps)
)(NavBarDesktop)
